import { createContext, useContext } from 'react';
import type { PaginatedFiltering } from './table.types';

export interface TablePaginationState {
  filtering: PaginatedFiltering;
  /** Every row is in: a filter or an option list built from the rows is the whole truth. */
  isComplete: boolean;
  /** `load-all` only: pull every remaining page (a checkbox filter is about to open). */
  requestAllRows: () => void;
}

/** Undefined on a table that holds all its rows. */
export const TablePaginationContext = createContext<TablePaginationState | undefined>(undefined);

export function useTablePagination() {
  return useContext(TablePaginationContext);
}
